<script lang="ts" setup>
import type { FormProps } from './state'
import Errors from './components/Errors.vue'
import Main from './components/Main.vue'
import Recorder from './components/Recorder.vue'
import { useForm } from './state'
import { useFormTheme } from './state.preview'

const props = defineProps<FormProps>()
const { state } = useForm(props)
const { Scope } = useFormTheme()
</script>

<template>
  <Scope v-if="state.isReady" class="wrapper h-full p-4 gap-4 text-$color-neutral bg-$color-background">
    <Errors v-if="state.error" />

    <Recorder v-else-if="state.hasStarted" />

    <!-- Starting screen -->
    <Main v-else />
  </Scope>
</template>

<style scoped lang="sass">
.wrapper > div
  @apply h-full gap-inherit flex flex-col

// Card styles
:deep(*)
  .card
    &, &-outline
      @apply flex-grow h-full p-4 gap-inherit bg-$header-bg rounded-10px overflow-hidden

    &-outline
      @apply bg-transparent border-1 border-solid border-$color-neutral-border
</style>
